import request from '@/utils/request';

const PATH = '/reservation/review';

export const getReservationReviewList = (params: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const replyReservationReview = (idx: any, data: any) => request({
  url: `${PATH}/reply/${idx}`,
  method: 'post',
  data,
});

export const deleteReservationReviewReply = (idx: any) => request({
  url: `${PATH}/reply/${idx}`,
  method: 'delete',
});
